import { FunctionComponent } from "react"
import { Alert, Button } from "react-bootstrap"
import Container from "react-bootstrap/Container"
import { useNavigate } from "react-router-dom"
import KeycardDoorsTable from "../components/KeycardDoorsTable"
import { useGetKeycardDoorsQuery } from "../hooks/queries/useGetKeycardDoorsQuery"

interface IKeycardDoorsPage {}
const KeycardDoorsPage: FunctionComponent<IKeycardDoorsPage> = () => {
	const keycardDoorsQuery = useGetKeycardDoorsQuery("keycard-doors")
	const keycardDoors = keycardDoorsQuery.data?.keycardDoors
	// loading layout
	const loading = !keycardDoors
	const error = keycardDoorsQuery.error
	if (loading) return <LoadingLayout error={error} />
	// normal layout
	return (
		<Container>
			<h2 className="text-center mt-4">Permissions</h2>
			<KeycardDoorsTable keycardDoorsQuery={keycardDoorsQuery} />
			<BackButton />
		</Container>
	)
}
export default KeycardDoorsPage

interface ILoadingLayout {
	error?: string
}
const LoadingLayout: FunctionComponent<ILoadingLayout> = ({ error }) => {
	return (
		<Container style={{ maxWidth: 500 }}>
			<h2 className="text-center mt-4">Permissions</h2>
			{error && <Alert variant={"warning"}>{error}</Alert>}
			<div className="text-center">Loading</div>
		</Container>
	)
}

const BackButton: FunctionComponent = () => {
	const navigate = useNavigate()
	return (
		<Button variant="secondary" className="mb-3" onClick={() => navigate(-1)}>
			Back
		</Button>
	)
}
